<template>
  <div class="color-legend">    
    <div class="root" ref="legendContainer"></div>
  </div>
</template>

<script>
import legend from '@/utils/ColorLegend'
import widgetContent from '@/mixins/widgetContent'
import d3 from '@/utils/d3importer'

export default {
  name: "ColorLegend",
  props: ['colorScale'],
  mixins: [widgetContent],
  mounted () {
    this.draw()
  },
  methods:{
    draw(){
      // let domain =this.colorScale.domain()
      // let domainStep = (domain[1] - domain[0])/10
      // let tickValues =  [...Array(11).keys()].map((i)=>domain[0]+domainStep*i)
      if(this.colorScale.domain()[0]===this.colorScale.domain()[1]) {
        this.$refs.legendContainer.innerHTML = '';
        let div = d3.select(this.$refs.legendContainer).append('div').attr('class','single-color').style("background",this.colorScale(0.5))
        // this.$refs.legendContainer.appendChild(document.createElement('div'))
      } else {
        let legendComp = legend({
          color: this.colorScale.nice(),
          title: null,
          // tickValues: tickValues, //this.colorScale.domain(),
          width: this.size.width*0.8
        })
        // UN poco guarro no poder hacer "update"....pero no parece muy grabe de momento
        this.$refs.legendContainer.innerHTML = '';
        this.$refs.legendContainer.appendChild(legendComp)
      }
    }
  },
  watch:{
    colorScale () {
      this.draw()
    },
    size () {
      this.draw()
    }
  }
}
</script>

<style scoped lang="stylus">
.color-legend
  width 100%
  height 46px
  position relative
  .root 
    width 80%
    height 100%
    left 10%
    position absolute
    margin auto
    // border solid 1px
    >>>.single-color
      width 100%
      height 6px
      margin-top: 15px
</style>